import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    ns: ['header', 'sidebar', 'dashboard', 'integrations', 'permissions', 'common', 'userRoles', 'usage', 'userManagement', 'profile', 'auth', 'suscriptions', 'organization'],
    defaultNS: 'header',
    load: 'languageOnly',
    // Disable i18next debug logs by default. Enable only if REACT_APP_I18N_DEBUG=true
    debug: process.env.REACT_APP_I18N_DEBUG === 'true',
    interpolation: { escapeValue: false },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      // Prefer explicit selections; do NOT use browser navigator to avoid auto-switching to Spanish
      order: ['localStorage', 'querystring', 'cookie', 'htmlTag'],
      // keys or params to lookup language from
      lookupQuerystring: 'lng',
      caches: ['localStorage', 'cookie'],
    },
  });

// Ensure first load defaults to English if no stored preference
try {
  const stored = (typeof window !== 'undefined') && window.localStorage ? window.localStorage.getItem('i18nextLng') : null;
  if (!stored) {
    i18n.changeLanguage('en');
  }
} catch (_) {
  // ignore storage errors
}

export default i18n;
